import { render, staticRenderFns } from "./ProjectSettingsModal.vue?vue&type=template&id=7d8e06d3&scoped=true&"
import script from "./ProjectSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSettingsModal.vue?vue&type=style&index=0&id=7d8e06d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8e06d3",
  null
  
)

export default component.exports